module.exports = __webpack_public_path__ + "static/media/my-account-bg.f5eb7b94.jpg";